import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { defaultHeaders, interceptToken } from '../config/axiosDefaults'
import { ModalSelector } from './modalSelector'
import { Notifications } from './notifications'
import { Header } from '../components/header'
import { hideModal } from '../actions/modalsActions'
import Routes from '../routes'
import * as Sentry from '@sentry/react'

//styles
import '../styles/main.scss'
import '../chassis/slider.css'
import '../chassis/tooltip.css'

interface Session {
  isAuth: boolean
}

export interface Props {
  session: Session
  dispatch: any
}

export class AppView extends Component<Props> {
  static displayName = 'App'

  componentWillMount() {
    defaultHeaders()
    interceptToken(this.props.dispatch)
  }

  render() {
    const { session } = this.props

    return (
      <div className="wrap" data-test="app-container">
        <section className="main-content container-fluid container-fluid--bleed">
          <Header session={session} />
          <Notifications />
          <Routes />
        </section>
        <ModalSelector />
      </div>
    )
  }
}

export const mapStateToProps = (state) => {
  const { session } = state
  return {
    session,
  }
}

export const mapDispatchToProps = (dispatch) => ({
  dispatch,
  hideModal: () => dispatch(hideModal()),
})

export const App = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AppView)
)
export default Sentry.withProfiler(App)
